export const AUTH_STORAGE = 'AUTH_STORAGE';

export const USERNAME_STORAGE_KEY = 'username';
export const INVITATION_LANDING_URL_STORAGE_KEY = 'INVITATION_LANDING_PAGE_PATH';
export const INVITATION_WORKSPACE_ID_STORAGE_KEY = 'INVITATION_WORKSPACE_ID';
export const INVITATION_INVITE_REFERENCE_STORAGE_KEY = 'INVITATION_INVITE_REFERENCE';
export const INVITATION_SOURCE_STORAGE_KEY = 'INVITATION_SOURCE';
export const INVITATION_BUSINESS_TYPE_STORAGE_KEY = 'INVITATION_BUSINESS_TYPE';

export const SAGE_50_BUSINESS_ID = 'SAGE_50_BUSINESS_ID';
export const SAGE_50_WORKSPACE_ID = 'SAGE_50_WORKSPACE_ID';
export const SAGE_50_ORGANISATION_ID = 'SAGE_50_ORGANISATION_ID';
export const SAGE_50_DATASOURCE_ID = 'SAGE_50_DATASOURCE_ID';

export const SFA_BUSINESS_ID = 'SFA_BUSINESS_ID';
